import { render, staticRenderFns } from "./SalesReportPage.vue?vue&type=template&id=1a5042da&scoped=true&"
import script from "./SalesReportPage.vue?vue&type=script&lang=js&"
export * from "./SalesReportPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesReportPage.vue?vue&type=style&index=0&id=1a5042da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5042da",
  null
  
)

export default component.exports